module.exports = __webpack_public_path__ + "img/s-hd.0af93286.webp";